/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { GradingMachineExcelTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const gradingMachineExcelShowBatchJobStatusSuccess = (state, { batchJobStatus }) => ({
  ...state,
  batchJobStatus
});

export const gradingMachineExcelUploadLoading = (state, { boolean }) => ({
  ...state,
  uploadIsLoading: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [GradingMachineExcelTypes.GRADING_MACHINE_EXCEL_SHOW_BATCH_JOB_STATUS_SUCCESS]: gradingMachineExcelShowBatchJobStatusSuccess,
  [GradingMachineExcelTypes.GRADING_MACHINE_EXCEL_UPLOAD_LOADING]: gradingMachineExcelUploadLoading
});
